import { render, staticRenderFns } from "./BillReceivebleStatsCard.vue?vue&type=template&id=2b1a28a3"
import script from "./BillReceivebleStatsCard.vue?vue&type=script&lang=js"
export * from "./BillReceivebleStatsCard.vue?vue&type=script&lang=js"
import style0 from "./BillReceivebleStatsCard.vue?vue&type=style&index=0&id=2b1a28a3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports